export default __webpack_public_path__ + "static/media/dota.d05f4b21.png";